var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26 0 0 5.634 0 12.6C0 22.05 14 36 14 36C14 36 28 22.05 28 12.6C28 5.634 21.74 0 14 0ZM4 12.6C4 7.632 8.48 3.6 14 3.6C19.52 3.6 24 7.632 24 12.6C24 17.784 18.24 25.542 14 30.384C9.84 25.578 4 17.73 4 12.6Z",
    fill: "#FFA318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0005 18.0996C16.7619 18.0996 19.0005 15.861 19.0005 13.0996C19.0005 10.3382 16.7619 8.09961 14.0005 8.09961C11.2391 8.09961 9.00049 10.3382 9.00049 13.0996C9.00049 15.861 11.2391 18.0996 14.0005 18.0996Z",
    fill: "#FFA318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarker);
export default __webpack_public_path__ + "static/media/icon_map_marker.3dc97c563ae410ff4e55080e0213ce59.svg";
export { ForwardRef as ReactComponent };